var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisputedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z",
    fill: "#FFC7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44443 13.1685C9.60888 13.0586 9.80222 13 10 13C10.2652 13 10.5196 13.1054 10.7071 13.2929C10.8946 13.4804 11 13.7348 11 14C11 14.1978 10.9414 14.3911 10.8315 14.5556C10.7216 14.72 10.5654 14.8482 10.3827 14.9239C10.2 14.9996 9.99889 15.0194 9.80491 14.9808C9.61093 14.9422 9.43275 14.847 9.29289 14.7071C9.15304 14.5673 9.0578 14.3891 9.01922 14.1951C8.98063 14.0011 9.00043 13.8 9.07612 13.6173C9.15181 13.4346 9.27998 13.2784 9.44443 13.1685Z",
    fill: "#E23636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 5.29289C9.48043 5.10536 9.73478 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12C9.73478 12 9.48043 11.8946 9.29289 11.7071C9.10536 11.5196 9 11.2652 9 11V6C9 5.73478 9.10536 5.48043 9.29289 5.29289Z",
    fill: "#E23636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputedIcon);
export default __webpack_public_path__ + "static/media/DisputedIcon.4ffa60b10610b37821ce534f928e0a38.svg";
export { ForwardRef as ReactComponent };